import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import { useAccess } from '../../../hooks/useAccess';
import { Paths } from '../../../shared/paths';
import Languages from '../languages/Languages';
import Translations from '../translations/Translations';
import AppAiPrompts from '../ai-prompts/AppAiPrompts';

export function LanguageManagementInnerTabs() {
  const { t } = useTranslation();
  const { access } = useAccess();
  const base = `${Paths.adminDashboard.root}${Paths.adminDashboard.languageManagement}`;
  const canViewLanguages = access?.languages?.canView ?? false;
  const canViewTranslations = access?.translations?.canView ?? false;
  const canViewAiPrompts = access?.aiPrompts?.canView ?? false;

  const tabsConfig = useMemo(() => {
    const tabs = [];

    if (canViewLanguages) {
      tabs.push({
        label: t('adminDashboard.languages'),
        path: `${base}/languages`,
      });
    }

    if (canViewTranslations) {
      tabs.push({
        label: t('adminDashboard.translations'),
        path: `${base}/translations`,
      });
    }

    if (canViewAiPrompts) {
      tabs.push({
        label: t('adminDashboard.aiPrompts'),
        path: `${base}/ai-prompts`,
      });
    }

    return tabs;
  }, [base, canViewAiPrompts, canViewLanguages, canViewTranslations, t]);

  const defaultTab =
    tabsConfig[0]?.path?.replace(`${base}/`, '')?.replace(/^\/+/, '') || '';

  return (
    <>
      <AppTabs config={tabsConfig} />
      <Box sx={{ mt: 2 }}>
        <Routes>
          {canViewLanguages && (
            <Route path="languages" element={<Languages />} />
          )}
          {canViewTranslations && (
            <Route path="translations" element={<Translations />} />
          )}
          {canViewAiPrompts && (
            <Route path="ai-prompts" element={<AppAiPrompts />} />
          )}
          <Route
            index
            element={<Navigate to={defaultTab || Paths.root} replace />}
          />
        </Routes>
      </Box>
    </>
  );
}
